import $ from 'jquery';
import * as ContactApi from './api';
import * as CustomerApi from 'modules/saas/customers/api';
import * as saasCustomerUsers from 'modules/saas/customers/users';
import * as saasCustomers from 'modules/saas/customers';

const handleFieldVisibility = isPro => {
  const $divToHide = isPro ? $('#par-fields') : $('#pro-fields');
  const $divToShow = isPro ? $('#pro-fields') : $('#par-fields');
  if ($divToHide && $divToHide.length && $divToShow && $divToShow.length) {
    const $fieldsToHide = $divToHide.find('.field');
    const $inputsToHide = $divToHide.find('input');

    $fieldsToHide.addClass('disabled');
    $inputsToHide.attr('disabled', true);
    $divToHide.hide();

    const $fieldsToShow = $divToShow.find('.field');
    const $inputsToShow = $divToShow.find('input');

    $fieldsToShow.removeClass('disabled');
    $inputsToShow.attr('disabled', false);
    $divToShow.show();
  }
};

export const displayCreationModal = (customer, onSaved) => {
  const $modal = $('#modal-create-contact');
  const $button = $modal.find('button[type="submit"]');
  saasCustomers.handleRestrictionsVisibility('has_own_address', 'address');

  $modal
    .find('form')
    .off('submit')
    .on('submit', evt => {
      evt.preventDefault();

      $button.addClass('loading');

      const $form = $(evt.target);
      const data = new FormData($form[0]);

      ContactApi.create(customer, data).then(
        site => {
          $button.removeClass('loading');
          $modal.modal('hide');

          onSaved(site);
        },
        error => {
          console.log('Error attempting to save contact', error);
          $button.removeClass('loading');

          error.res.text().then(content => $modal.find('form').html(content));
          saasCustomerUsers.edit();
        }
      );
    });

  $modal.modal({
    onVisible: () => {
      saasCustomerUsers.edit();
    },
    onHidden: () => {
      // Clearing form
      $modal.find('input').val('');
    },
  });

  CustomerApi.getById(customer).then(res => {
    handleFieldVisibility(res.is_company);
    $modal.modal('show');
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/contacts/modals.js